<template>
  <div class="management-header">
    <div class="left">
      <div class="logo">
        <img
          src="/img/logo/mf_logo_white_small_v.png"
          alt="logo"
          class="logo-icon"
          @click="onReload"
        />
      </div>
    </div>
    <div class="center">
      <div v-if="loginState.userData" class="header-menu">
        <router-link
          to="/license"
          class="link"
          active-class="active"
          v-if="
            loginState.userData.userType == 1000 ||
            loginState.userData.userType == 100
          "
          >{{ $t("Header_License") }}</router-link
        >
        <router-link to="/template" class="link" active-class="active"
          >{{ $t("Header_Template") }}</router-link
        >
        <router-link
          to="/attach"
          class="link"
          active-class="active"
          v-if="
            loginState.userData.userType == 1000 ||
            loginState.userData.userType == 100
          "
          >{{ $t("Header_Attachments") }}</router-link
        >
        <router-link
          to="/user"
          class="link"
          active-class="active"
          v-if="loginState.userData.userType == 1000"
          >{{ $t("Header_User") }}</router-link
        >
        <router-link
          to="/log"
          class="link"
          active-class="active"
          v-if="
            loginState.userData.userType == 1000 ||
            loginState.userData.userType == 100
          "
          >{{ $t("Header_Log") }}</router-link
        >
      </div>
    </div>
    <div class="right">
      <!-- 언어 선택 -->
      <a-dropdown placement="bottomCenter" :trigger="['click']">
        <button><GlobalOutlined />{{ curLanguage }}</button>
        <template #overlay>
          <a-menu @click="changeLang">
            <a-menu-item key="ko">한국어</a-menu-item>
            <a-menu-item key="ja">日本語</a-menu-item>
            <a-menu-item key="en">English</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>

      <button v-if="loginState.userData" @click="pwChange">
        {{$t("Header_Change_Password")}}
      </button>

      <button v-if="loginState.userData" @click="onLogout" class="logout">
        Logout
      </button>
    </div>
    <ChangePasswdModal
      v-if="chagePasswdVisible"
      :visible="chagePasswdVisible"
      :toggleModal="() => toggleModal('chagePasswdVisible')"
    />
  </div>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/utils/common";
import { useStore } from "vuex";
import { computed, onUpdated, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { GlobalOutlined } from "@ant-design/icons-vue";

import ChangePasswdModal from "@/components/sideComponents/ChangePasswdModal";

export default {
  name: "Header",
  components: {
    ChangePasswdModal,
    GlobalOutlined,
  },
  setup() {
    const store = useStore();
    const loginState = computed(() => store.getters["login/STATE"]);
    const router = useRouter();

    const state = reactive({
      chagePasswdVisible: false,
    });

    const localLang = localStorage.getItem("language");
    let curLanguage = "한국어";
    if (localLang === "ko") {
      curLanguage = "한국어";
    } else if (localLang === "ja") {
      curLanguage = "日本語";
    } else if (localLang === "en") {
      curLanguage = "English";
    }

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    const pwChange = () => {
      toggleModal("chagePasswdVisible");
    };

    // 언어 변경
    const changeLang = (menu) => {
      localStorage.setItem("language", menu.key);
      onReload();
    };

    const onLogout = () => {
      localStorage.removeItem("loginAdmin");
      localStorage.removeItem("loginUser");
      sessionStorage.removeItem("curUser");

      // 로그아웃 처리
      axios.get(apiUrl + "Login/Logout", {});
      store.dispatch("user/LOGOUT");

      // 로그인 초기화
      store.dispatch("login/SET_INIT", { userData: null });

      // 로그인 화면으로 이동
      router.push("/login");
    };

    const onReload = () => {
      window.location.reload();
    };

    return {
      ...toRefs(state),
      loginState,
      curLanguage,
      onLogout,
      onReload,
      pwChange,
      toggleModal,
      changeLang,
    };
  },
};
</script>